import { Layout } from 'antd';

const { Footer: Foot } = Layout;

function Footer() {
  return <Foot style={{ textAlign: 'center' }}>MySG ©2025 Train Pursuit</Foot>;
}

export default Footer;
